import { groupBy, orderBy } from 'lodash';

import EdCom from './EdCom';
import Error from './Error';
import FacilityManagement from './FacilityManagement';
import LMSAdmin from './LMSAdmin';
import MessagePortal from './MessagePortal';
import MyProfile from './MyProfile';
import MySpace from './MySpace';
import Organization from './Organization';
import PeopleRecords from './PeopleRecords';
import SiteManagement from './SiteManagement';
import System from './System';
import Programs from './Programs';
import EContent from './EContent';
import EdDrive from './EdDrive';
import Translation from './Translation';

export const AllModules = [
  PeopleRecords,
  Organization,
  MessagePortal,
  MyProfile,
  EdCom,
  SiteManagement,
  LMSAdmin,
  FacilityManagement,
  MySpace,
  System,
  Programs,
  EContent,
  EdDrive,
  Translation,

  Error, // should be last
].map(module => ({
  permission: `${module.group ? `${module.group}.` : ''}${module.id}`,
  ...module,
}));

export const ModulesById = AllModules.reduce((byId, module) => {
  byId[module.id] = module;
  return byId;
}, {});

export const ModulesGroupsMeta = {
  administration: {
    id: 'administration',
    title: 'Administration',
  },
  hr: {
    id: 'hr',
    title: 'HR Management',
  },
  lms: {
    id: 'lms',
    title: 'Learning Management System',
  },
  financial: {
    id: 'financial',
    title: 'Financial',
  },
  facilities: {
    id: 'facilities',
    title: 'Facilities',
  },
  setup: {
    id: 'setup',
    title: 'Setup',
  },
  zone: {
    id: 'zone',
    title: 'My Zone',
  },
  general: {
    id: 'general',
    title: 'General',
  },
  programs: {
    id: 'programs',
    title: 'Programs',
  },
};

export const AdministrationModulesGroup = [
  {
    ...ModulesGroupsMeta.administration,
    modules: groupModules('administration').filter(
      module => module.id !== 'my_space',
    ),
  },
  {
    ...ModulesGroupsMeta.hr,
    modules: groupModules('hr'),
  },
  {
    ...ModulesGroupsMeta.lms,
    modules: groupModules('lms'),
  },
  {
    ...ModulesGroupsMeta.financial,
    modules: groupModules('financial'),
  },
  {
    ...ModulesGroupsMeta.facilities,
    modules: groupModules('facilities'),
  },
];

export const SetupModulesGroup = [
  {
    ...ModulesGroupsMeta.setup,
    modules: groupModules('setup'),
  },
];

export const ProfileModulesGroup = [
  {
    ...ModulesGroupsMeta.zone,
    modules: groupModules('zone').filter(
      module => module.id !== 'ed_drive' && module.id !== 'library_search',
    ),
  },
];

export const SetupModulesSubGroups = [
  {
    ...ModulesGroupsMeta.setup,
    hasSubGroups: true,
    subGroupsOrder: {
      [ModulesGroupsMeta.administration.id]: 1,
      [ModulesGroupsMeta.hr.id]: 2,
      [ModulesGroupsMeta.lms.id]: 3,
      [ModulesGroupsMeta.programs.id]: 4,
      [ModulesGroupsMeta.financial.id]: 5,
      [ModulesGroupsMeta.facilities.id]: 6,
      [ModulesGroupsMeta.general.id]: 7,
    },
    modules: groupModulesWithSubGroups('setup'),
  },
];

export const ModuleByGroups = AdministrationModulesGroup.concat(
  SetupModulesGroup,
  ProfileModulesGroup,
);

function groupModules(groupName) {
  const modules = AllModules.filter(m => m.group === groupName);
  return orderBy(modules, 'order');
}

function groupModulesWithSubGroups(groupName) {
  let modules = AllModules.filter(module => module.group === groupName);

  const modulesSubGroups = groupBy(modules, 'subGroup');

  modules = Object.keys(modulesSubGroups).map(key => ({
    ...ModulesGroupsMeta[key],
    modules: orderBy(modulesSubGroups[key], 'order'),
  }));

  return modules;
}
